import { memo } from "react";
import { useTransactionContext } from "../../TransactionProvider";
import CodeSnippet from "ui/molecules/CodeSnippet";

const Response = () => {
    const transaction = useTransactionContext();

    return (
        <CodeSnippet
            data={transaction.transactionResponse}
        />
    );
};

export default memo(Response);
